<div class="container" [class.is-mobile]="mobileQuery.matches">
  <mat-toolbar color="primary" class="toolbar && mat-elevation-z5">
    <mat-toolbar-row>
      <ng-container *ngIf="user; else noLogged">
        <button mat-icon-button (click)="snav.toggle()">

          <ng-container *ngIf="notifications && notifications > 0; else nothing">
            <mat-icon matBadge="{{notifications}}" matBadgeColor="warn">menu</mat-icon>
          </ng-container>
          <ng-template #nothing>
            <mat-icon>menu</mat-icon>
          </ng-template>
        </button>
      </ng-container>
      <ng-template #noLogged>
        <span class="material-icons && back-nav">home</span>
        <div style="margin-right: 30px"></div>
      </ng-template>
      <h1 class="app-name">IBD Tool</h1>
    </mat-toolbar-row>
  </mat-toolbar>

  <mat-sidenav-container class="sidenav-container"
                         [style.marginTop.px]="mobileQuery.matches ? 56 : 0">
    <mat-sidenav class="custom-sidenav" #snav [mode]="mobileQuery.matches ? 'over' : 'side'"
                 [fixedInViewport]="mobileQuery.matches" fixedTopGap="56">

      <ng-container *ngIf="user">
        <div (swiperight)="onSwipe($event)"></div>
        <div style="text-align: center; padding-bottom: 10px">
          <mat-icon style="width:50px; height:50px; font-size:50px;">account_circle</mat-icon>
        </div>
        <div style="padding-bottom: 30px; text-align: center; font-weight: bold">{{user.name}} {{user.surname}}</div>
        <mat-divider class="custom-divider"></mat-divider>
        <div style="padding-bottom: 10px"></div>
        <div style="text-align: center">
          <ng-container *ngIf="!messagesUnread">
            <span *ngIf="user.role.includes('PAZIENTE')" id="chatIconPatient" class="material-icons" routerLink="/patient-chat">chat</span>
            <span *ngIf="user.role.includes('DOTTORE')" id="chatIconDoctor" class="material-icons" routerLink="/doctor-chat">chat</span>
          </ng-container>
          <ng-container *ngIf="messagesUnread">
            <span *ngIf="user.role.includes('PAZIENTE')" matBadge="!" matBadgeColor="warn" id="chatIconPatientUnread" class="material-icons" routerLink="/patient-chat">chat</span>
            <span *ngIf="user.role.includes('DOTTORE')" matBadge="!" matBadgeColor="warn"  id="chatIconDoctorUnread" class="material-icons" routerLink="/doctor-chat">chat</span>
          </ng-container>
        </div>
        <ng-container *ngIf="notifications && notifications > 0; else noNotifications">
          <div style="text-align: center">
            <span class="material-icons" matBadge="{{notifications}}" routerLink="/notifications" matBadgeColor="warn" style="cursor: pointer; vertical-align: middle">notifications</span>
          </div>
        </ng-container>
        <ng-template #noNotifications>
          <div style="text-align: center">
            <span class="material-icons" routerLink="/notifications" style="cursor: pointer; vertical-align: middle">notifications</span>
          </div>
        </ng-template>
        <div style="padding-bottom: 15px"></div>
        <a mat-list-item (click)="goToSettings()">Impostazioni</a>
        <ng-container *ngIf="back">
          <div style="padding-bottom: 10px"></div>
          <a mat-list-item (click)="goTo('landing')">Pagina iniziale</a>
          <div style="padding-bottom: 10px"></div>
          <a mat-list-item (click)="goTo(destination)">Torna indietro</a>
        </ng-container>
        <div style="padding-bottom: 10px"></div>
        <a mat-list-item (click)="onLogout()">Esci</a>
      </ng-container>
      <mat-nav-list>
      </mat-nav-list>
    </mat-sidenav>

  </mat-sidenav-container>
</div>
